<template>
  <v-container class="pt-3 pb-6 px-6">
    <!-- Page Header -->
    <page-header
      title="Cambio de contraseña"
      icon="mdi-account"
      divider="-"
      :breadcrumbs="breadcrumbs.items"
    ></page-header>
    <v-row align="center" justify="space-around">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-form ref="form" v-model="isFormValid">
              <!-- System User Subtitle -->
              <v-row dense>
                <v-col cols="12">
                  <span class="subtitle-1">Usuario del sistema:</span>
                </v-col>
              </v-row>
              <v-row>
                <!-- Password -->
                <v-col cols="4">
                  <v-text-field
                    v-model="currentPassword"
                    type="password"
                    label="Contraseña actual"
                    outlined
                    counter="30"
                    maxlength="30"
                    :rules="[fieldRules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="newPassword"
                    :type="showPassword ? 'text' : 'password'"
                    label="Contraseña"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    outlined
                    counter="30"
                    maxlength="30"
                    hint="Entre 6 y 30 caracteres. Debe contener al menos una mayúscula, una minúscula y un número."
                    persistent-hint
                    :rules="[fieldRules.emailFormat]"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn text class="mr-4" :to="{ name: 'home'}">Cancelar</v-btn>
                  <v-btn
                    color="primary"
                    :loading="isSubmitting"
                    :disabled="!isFormValid || isSubmitting"
                    @click="handleSubmit"
                  >Guardar</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { UserRepository } from "@/api/Repositories";
import PageHeader from "@/components/PageHeader";
import Util from "@/util";

export default {
  components: {
    PageHeader
  },

  // Props
  props: {},

  // Data
  data: () => ({
    isFormValid: true,
    isSubmitting: false,
    breadcrumbs: {
      items: [
        {
          text: "Configuración",
          disabled: true
        },
        {
          text: "Usuarios",
          disabled: true
        }
      ]
    },
    currentPassword: null,
    newPassword: null,
    showPassword: false,
    fieldRules: {
      required: v => (!!v && !!v.trim()) || "Obligatorio.",
      emailFormat: v =>
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/.test(v) ||
        "El formato de la contraseña no es correcto. Debe tener entre 6 y 30 caracteres. Debe contener al menos una mayúscula, una minúscula y un número."
    },
    confirmPassRules: [
      v => !!v || "Requerido",
      v => this.password_new === undefined || "Introduce contraseña",
      v => v !== this.password_new || "Contraseña diferente"
    ]
  }),
  methods: {
    handleSubmit(e) {
      this.isSubmitting = true;
      UserRepository.changeOwnPassword(this.currentPassword, this.newPassword)
        .then(_ => {
          this.$refs.form.reset();
          this.$toast("Contraseña cambiada correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information",
            showClose: true,
            closeText: "Cerrar"
          });
        })
        .catch(err => {
          Util.showErrorToast(
            this,
            err,
            "No se ha podido cambiar la contraseña."
          );
          console.log(err.response.status);
        })
        .finally(f => {
          this.isSubmitting = false;
        });
    }
  }
};
</script>
